import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { PropsWithChildren } from "react";
import { marlinTheme } from "~/services/theme";

export default function MarlinThemeProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider theme={marlinTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        {children}
      </Box>
    </ThemeProvider>
  );
}
